"use strict";

var _global = require("global");

_global.window.STORYBOOK_REACT_CLASSES = {};